import { StyledDescription } from './styles';

export default StyledDescription;
